import React from "react";
import DownloadVotersListComponent from "./DownloadVotersList";

const DownloadVotersList = () => {
    return <DownloadVotersListComponent />;
};

export default DownloadVotersList;
